import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

/** Props for {@link ClassLandingRevokeConfirmDialog}. */
interface ClassLandingRevokeConfirmDialogProps {
  /** Whether the dialog is shown. */
  open: boolean;
  /** Disables the buttons (and closing) while the confirmed enroll is in flight. */
  submitting: boolean;
  /** Keeps the current code and closes the dialog. */
  onCancel: () => void;
  /** Enrols again with `confirmRevoke: true`. */
  onConfirm: () => void;
}

/**
 * Shown when the backend returns `SS_REDEEM_CONFIRM_REVOKE`: the student already has
 * current access with another bookstore code. Confirming revokes that code and enrols them
 * with the new one. API errors from the resubmit show in the page's alert box and the dialog
 * stays open.
 */
const ClassLandingRevokeConfirmDialog: React.FC<
  ClassLandingRevokeConfirmDialogProps
> = ({ open, submitting, onCancel, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onCancel}
      aria-labelledby="ss-revoke-dialog-title"
      PaperProps={{ className: "ss-public-dialog" }}
    >
      <DialogTitle id="ss-revoke-dialog-title">Replace access code?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You already have access for this class. Continuing will revoke your
          existing access code and enroll you with this new code.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className="ss-public-dialog-cancel"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          className="ss-public-dialog-confirm"
          onClick={onConfirm}
          disabled={submitting}
        >
          Replace and continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClassLandingRevokeConfirmDialog;
